import React, { useCallback, useState } from 'react';
import Visibility from '../../components/Visibility';
import './style.scss';
import DesktopContent from './Desktop';
import MobileContent from './Mobile';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 15 });

export function Portrait2() {
  const [progress, setProgress] = useState(0);
  const [mobile, setMobile] = useState(false);
  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      setMobile(width <= 750);
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-portrait-2 inverted" data-track={track}>
      {!mobile && <DesktopContent progress={progress} />}
      {mobile && <MobileContent progress={progress} />}
    </Visibility>
  );
}
